module.exports = __webpack_public_path__ + "fonts/Inter-900-greek81.8c7f6ae.woff2";